import { z } from 'zod';

import { dashboardT } from '../../../lib/messages';
import { EndpointAdServerType, EndpointIntegrationType, EndpointRegion } from './model';

export const endpointGeneratorFormSchema = z
  .object({
    publisherId: z.string(),
    placementId: z.string(),
    deliveryType: z.string().optional(),
    adServerType: z.enum(EndpointAdServerType),
    integrationType: z.enum(EndpointIntegrationType),
    region: z.enum(EndpointRegion),
    audio: z.boolean(),
  })
  .superRefine((value, context) => {
    if (!value.publisherId) {
      context.addIssue({
        code: 'custom',
        path: ['publisherId'],
        message: dashboardT('endpointGenerator.validation.publisher'),
      });
    }
    if (!value.placementId) {
      context.addIssue({
        code: 'custom',
        path: ['placementId'],
        message: dashboardT('endpointGenerator.validation.placement'),
      });
    }
  });

export type EndpointGeneratorFormValue = z.infer<typeof endpointGeneratorFormSchema>;
